module.exports = __webpack_public_path__ + "img/check_out.6f632f1f.svg";